import { render } from "./gello.vue?vue&type=template&id=3d78a213&scoped=true"
import script from "./gello.vue?vue&type=script&lang=js"
export * from "./gello.vue?vue&type=script&lang=js"

import "./gello.vue?vue&type=style&index=0&id=3d78a213&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d78a213"]])

export default __exports__